import React, { useState } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";

// Hangar
import { Button } from "@maxmilhas/hangar-components-atomic/public";

// Components
import Stretch from "./Stretch";

// Style
import { styleOffer } from "./style";

const OfferCombo = ({
	offer,
	dictionaries,
	tripType,
	onSelectCombo,
	onClearSelected,
	isSelected
}) => {
	const [outbound, setOutbound] = useState();
	const [inbound, setInbound] = useState();
	const handleSelectCombo = () => {
		if (typeof onSelectCombo === "function") {
			onSelectCombo({ outbound, inbound });
		}
	};
	return (
		<div
			className={css`
				${styleOffer}
			`}
		>
			<Stretch
				direction="outbound"
				offerId={offer.id}
				bounds={offer.bounds.filter(bound => bound.number === 0)}
				filters={offer.index.bounds.filter(bound => bound.number === 0)}
				dictionaries={dictionaries}
				onChangeBounds={setOutbound}
			/>
			{tripType === "RT" && (
				<Stretch
					direction="inbound"
					offerId={offer.id}
					bounds={offer.bounds.filter(bound => bound.number === 1)}
					filters={offer.index.bounds.filter(bound => bound.number === 1)}
					dictionaries={dictionaries}
					onChangeBounds={setInbound}
				/>
			)}
			{isSelected ? (
				<Button onClick={onClearSelected} outline>
					Selecionar outro voo
				</Button>
			) : (
				<Button onClick={handleSelectCombo}>Selecionar</Button>
			)}
		</div>
	);
};

OfferCombo.propTypes = {
	offer: PropTypes.object,
	dictionaries: PropTypes.object,
	tripType: PropTypes.oneOf(["RT", "OW"]),
	onSelectCombo: PropTypes.func,
	onClearSelected: PropTypes.func,
	isSelected: PropTypes.bool
};

OfferCombo.defaultProps = {
	offer: null,
	dictionaries: null,
	tripType: "OW",
	onSelectCombo: null,
	onClearSelected: null,
	isSelected: false
};

export default OfferCombo;
